import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

// Usage: <ProtectedRoute allowedRoles={['admin']}>...</ProtectedRoute>
function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  // While restoring session from localStorage, show a centered spinner
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Not logged in — go to login
  if (!user) return <Navigate to="/login" replace />;

  // Forced first-login password change — block every protected route (admin/trainer/
  // student) until the temp password is replaced. Survives refresh / direct URL because
  // mustChangePassword is hydrated from /me, not just the login response.
  if (user.mustChangePassword) return <Navigate to="/change-password" replace />;

  // Logged in but wrong role — redirect to their own dashboard
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={`/${user.role}/dashboard`} replace />;
  }

  return children;
}

export default ProtectedRoute;
